import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BASE_API_URL } from "../../../../../../core/environment.tokens";
import { ChaseDetailForAuditItem } from "../../../chase-detail-for-audit-item.model";
import { AuditQueryGridFilters } from "../../audit-query-shared/audit-query-grid-filters/audit-query-grid-filter-model";
import { IAuditQueryGridData } from "../../audit-query-shared/audit-query-grid-filters/member-radv-record.model";

@Injectable({
  providedIn: "root",
})
export class AuditQueryGridRiskService {
  private gridFiltersRisk = new BehaviorSubject<AuditQueryGridFilters>(new AuditQueryGridFilters());
  auditGridFilter = this.gridFiltersRisk.asObservable();
  auditGridFilterToRefreshGrid: AuditQueryGridFilters;

  private pGridRefreshFromState = new BehaviorSubject(null);
  gridRefreshFromStateFilter = this.pGridRefreshFromState.asObservable();

  private memberRadvCardData = new BehaviorSubject<IAuditQueryGridData[]>(new Array<IAuditQueryGridData>());
  memberRadvCard = this.memberRadvCardData.asObservable();

  constructor(
    @Inject(BASE_API_URL)
    private readonly baseApiUrl: string,
    private http: HttpClient
  ) { }

  resetGridFilter(value: AuditQueryGridFilters): void {
    this.gridFiltersRisk.next(value);
    this.auditGridFilterToRefreshGrid = value;
  }

  refreshAuditGrid(): void {
    this.gridFiltersRisk.next(this.auditGridFilterToRefreshGrid);
  }

  reloadAuditGridFromState(value?: any): void {
    this.pGridRefreshFromState.next(value);
  }

  saveAuditReadyStatus(chaseAuditData: ChaseDetailForAuditItem): Observable<IAuditQueryGridData[]> {
    const url = `${this.baseApiUrl}audit/auditready`;

    return this.http.post(url, chaseAuditData)
      .pipe(map((response: any) => response as IAuditQueryGridData[]));
  }

  sendMemberRadvCardData(memberRadvCard: IAuditQueryGridData[]): void {
    this.memberRadvCardData.next(memberRadvCard);
  }
}
